import { createSlice } from "@reduxjs/toolkit";
import { fetchProfile } from "../thunks/fetch-profile-thunk";
import { postProfile } from "../thunks/post-profile-thunk";

const initialState = {
    profile: {
        suffix: "",
        firstName: "",
        lastName: "",
        middleName: "",
        phoneNumber: "",
        dob: "",
        gender: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zipcode: "",
        navajoTribeMember: "",
        currentlyEmployed: "",
        census: "",
        nationality: "",
        hasDriverLicense: "",
        driverLicenseNumber: "",
        driverLicenseClass: "",
        driverLicenseState: "",
        driverLicenseExpirationDate: "",
        driverLicenseType: "",
        attendedHighSchool: "",
        highSchoolName: "",
        highSchoolAddress: "",
        education: "",
        highSchoolStart: "",
        highSchoolEnd: "",
        attendedCollege1: "",
        collegeName1: "",
        collegeAddress1: "",
        degree1: "",
        major1: "",
        minor1: "",
        collegeStart1: "",
        collegeEnd1: "",
        attendedCollege2: "",
        collegeName2: "",
        collegeAddress2: "",
        degree2: "",
        major2: "",
        minor2: "",
        collegeStart2: "",
        collegeEnd2: "",
        attendedTechSchool: "",
        techSchoolName1: "",
        techSchoolAddress1: "",
        techDegree1: "",
        techMajor1: "",
        techMinor1: "",
        techStart1: "",
        techEnd1: "",
        trainingName1: "",
        trainingStart1: "",
        trainingEnd1: "",
        trainingName2: "",
        trainingStart2: "",
        trainingEnd2: "",
        trainingName3: "",
        trainingStart3: "",
        trainingEnd3: "",
        trainingName4: "",
        trainingStart4: "",
        trainingEnd4: "",
        skillName1: "",
        skillName2: "",
        skillName3: "",
        skillName4: "",
        felony: "",
        felonyDate: "",
        felonyReason: "",
        misdemeanor: "",
        misdemeanorDate: "",
        misdemeanorReason: "",
        physical: "",
        physicalName1: "",
        physicalReason1: "",
        physicalName2: "",
        physicalReason2: "",
        physicalName3: "",
        physicalReason3: "",
        relations: "",
        relationsRelationship1: "",
        relationsName1: "",
        relationsDepartment1: "",
        relationsRelationship2: "",
        relationsName2: "",
        relationsDepartment2: "",
        employer1: "",
        employerAddress1: "",
        employerStart1: "",
        employerEnd1: "",
        employerSupervisor1: "",
        employerJobTitle1: "",
        employerPhone1: "",
        employerReason1: "",
        employerDuties1: "",
        employer2: "",
        employerAddress2: "",
        employerStart2: "",
        employerEnd2: "",
        employerSupervisor2: "",
        employerJobTitle2: "",
        employerPhone2: "",
        employerReason2: "",
        employerDuties2: "",
        employer3: "",
        employerAddress3: "",
        employerStart3: "",
        employerEnd3: "",
        employerSupervisor3: "",
        employerJobTitle3: "",
        employerPhone3: "",
        employerReason3: "",
        employerDuties3: "",
        employer4: "",
        employerAddress4: "",
        employerStart4: "",
        employerEnd4: "",
        employerSupervisor4: "",
        employerJobTitle4: "",
        employerPhone4: "",
        employerReason4: "",
        employerDuties4: "",
        employer5: "",
        employerAddress5: "",
        employerStart5: "",
        employerEnd5: "",
        employerSupervisor5: "",
        employerJobTitle5: "",
        employerPhone5: "",
        employerReason5: "",
        employerDuties5: "",
        employer6: "",
        employerAddress6: "",
        employerStart6: "",
        employerEnd6: "",
        employerSupervisor6: "",
        employerJobTitle6: "",
        employerPhone6: "",
        employerReason6: "",
        employerDuties6: "",
        employer7: "",
        employerAddress7: "",
        employerStart7: "",
        employerEnd7: "",
        employerSupervisor7: "",
        employerJobTitle7: "",
        employerPhone7: "",
        employerReason7: "",
        employerDuties7: "",
        employer8: "",
        employerAddress8: "",
        employerStart8: "",
        employerEnd8: "",
        employerSupervisor8: "",
        employerJobTitle8: "",
        employerPhone8: "",
        employerReason8: "",
        employerDuties8: "",
        employer9: "",
        employerAddress9: "",
        employerStart9: "",
        employerEnd9: "",
        employerSupervisor9: "",
        employerJobTitle9: "",
        employerPhone9: "",
        employerReason9: "",
        employerDuties9: "",
        employer10: "",
        employerAddress10: "",
        employerStart10: "",
        employerEnd10: "",
        employerSupervisor10: "",
        employerJobTitle10: "",
        employerPhone10: "",
        employerReason10: "",
        employerDuties10: "",
        veteran: "",
        cibFormIn: "",
        rifFormIn: "",
        rifDate: "",
        rif: "",
        DD214OnFile: "",
        NN_Spouse: "",
        NN_SpousePrefEligible: "",
        NN_SpouseCensus: "",
        Veteran_DD214Form_OriginalName: "",
        Veteran_DD214Form_UploadDate: "",
        Veteran_DD214Form_FileSize: "",
        RIF_Form_OriginalName: "",
        RIF_Form_UploadDate: "",
        RIF_Form_FileSize: "",
        NN_CIBForm_OriginalName: "",
        NN_CIBForm_UploadDate: "",
        NN_CIBForm_FileSize: "",
    },

    status: "idle",
    error: null,
};

export const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchProfile.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchProfile.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.profile = action.payload;
            })
            .addCase(fetchProfile.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })
            .addCase(postProfile.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.profile = action.meta.arg;
            });
    },
});

export const selectProfile = (state) => state.profile.profile;
